// extracted by mini-css-extract-plugin
module.exports = {"hidden":"VisuallyHidden_hidden__Pgq2G"};